export const defaultUrl = process.env.REACT_APP_SCRIPTS_URL;
export const apiServerUrl = process.env.REACT_APP_API_SERVER;
export const profileUrl = process.env.REACT_APP_PROFILE_URL;
export const readerUrl = process.env.REACT_APP_READER_URL;
